import { IStepBlockingAction } from '../types/createSendFlow';
import { ICreateSendRecipientsState, ShippingModeEnum, TRecipientsBlockReason } from '../types/createSendRecipients';

export const DEFAULT_CREATE_SEND_RECIPIENTS_STATE: ICreateSendRecipientsState = {
  addressMode: ShippingModeEnum.YouProvide,
  claimLinkMode: ShippingModeEnum.RecipientDecides,
  multiKitAddressMode: ShippingModeEnum.RecipientDecides,
  recipients: [],
  overrideAddress: null,
  oneTimeAddress: null,
  selectedClaimAddressIds: [],
};

export const BULK_RECIPIENTS_THRESHOLD = 2;

export const RELEASE_DATE_BLOCK_MESSAGE = 'Pick a release date for the hold, or turn Put on hold off';

export const BUSINESS_REASON_BLOCK_MESSAGE = 'No business reason selected';

export const BUSINESS_REASON_BLOCK_ACTION: IStepBlockingAction = {
  label: 'Select a reason',
  target: 'business-reason',
};

export const RECIPIENTS_BLOCK_MESSAGE: Record<TRecipientsBlockReason, string> = {
  'no-recipients': 'Add at least one recipient to continue',
  'from-list-needs-2': 'Select at least two addresses for recipients to choose from',
  'incomplete-recipient': 'Complete the required shipping details to continue',
  'business-reason-required': BUSINESS_REASON_BLOCK_MESSAGE,
  'crm-record-required': 'Select a CRM contact to continue',
  'crm-status-unknown': 'Checking your organization settings',
  'release-date-required': RELEASE_DATE_BLOCK_MESSAGE,
  'bulk-requires-admin': 'Your role can send to one recipient at a time — remove the others to continue',
};

export const ADDED_FLASH_MS = 1500;

export const HIGHLIGHT_SAFETY_MS = 6000;

export const COMPACT_WARNING_THRESHOLD = 30;

export const VIRTUALIZE_THRESHOLD = 30;

export const RECIPIENTS_HEADER_CONTAINER_NAME = 'recipients-header';

export const RECIPIENTS_HEADER_SINGLE_ROW_MIN_WIDTH = 950;

export const SHIPPING_ADDRESS_CONTAINER_NAME = 'recipients-shipping-address';

export const SHIPPING_MODE_CARDS_STACK_MAX_WIDTH = 560;
